// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"887":"340ceddd","941":"84dd409f"}[chunkId] + ".js";
};